import { render, staticRenderFns } from "./xlxs-uploader.vue?vue&type=template&id=3c5228aa"
import script from "./xlxs-uploader.vue?vue&type=script&lang=js"
export * from "./xlxs-uploader.vue?vue&type=script&lang=js"
import style0 from "./xlxs-uploader.vue?vue&type=style&index=0&id=3c5228aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports